import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    margin: theme.spacing(4, 0, 0, 0),
  },
  titleButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
  },
  buttonsContainer: {
    display: 'flex',
    gap: theme.spacing(2),
  },
}));

export default useStyles;
